import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { motion } from 'framer-motion';
import { XCircle, ArrowRight } from '@phosphor-icons/react';
import { Button } from '../components/ui/button';

export default function PaymentCancelPage() {
  const { t } = useLanguage();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#050505] flex flex-col items-center justify-center px-6" data-testid="payment-cancel-page">
      <motion.div
        className="max-w-sm w-full p-6 rounded-3xl bg-[#0a0a0a] border border-white/5 text-center"
        initial={{ opacity: 0, y: 16, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.4 }}
      >
        <div className="w-16 h-16 mx-auto rounded-full bg-[#FF5A00]/15 flex items-center justify-center mb-4">
          <XCircle size={32} weight="fill" className="text-[#FF5A00]" />
        </div>
        <p className="text-xl font-bold text-white">{t('paymentCancelled')}</p>
        <p className="text-sm text-white/55 mt-1">{t('paymentCancelledDesc')}</p>
        <Button
          onClick={() => navigate('/')}
          className="cta-button-primary w-full h-12 rounded-xl mt-6 text-sm font-semibold"
          data-testid="payment-cancel-home-btn"
        >
          {t('backToHome')}
          <ArrowRight size={16} className="ml-2" />
        </Button>
      </motion.div>
    </div>
  );
}
